// @ts-nocheck
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
// Tambahkan modul ke Swiper
Swiper.use([Autoplay, Navigation, EffectFade, Pagination]);

export function initHomeSwiper() {
    // eslint-disable-next-line no-unused-vars
    var swiper1 = new Swiper(".mySwiperHomeVenue", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
            },
            768: {
            slidesPerView: 3,
            spaceBetween: 40,
            },
            1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            },
        },
    });

    // eslint-disable-next-line no-unused-vars
    var swiper2 = new Swiper(".mySwiperIntercon", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
    });

    // eslint-disable-next-line no-unused-vars
    var swiper3 = new Swiper(".mySwiperHomeEvent", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
    });

    // eslint-disable-next-line no-unused-vars
    var swiper4 = new Swiper(".mySwiperHomePackage", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-package",
          prevEl: ".swiper-button-prev-package",
        },
        breakpoints: {
            640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
            },
            768: {
            slidesPerView: 3,
            spaceBetween: 40,
            },
            1024: {
            slidesPerView: 2,
            spaceBetween: 20,
            },
        },
    });

    // eslint-disable-next-line no-unused-vars
    var swiper5 = new Swiper(".mySwiperReview", {
        navigation: {
          nextEl: ".swiper-button-next-review",
          prevEl: ".swiper-button-prev-review",
        }
    });

    // eslint-disable-next-line no-unused-vars
    const swiper10 = new Swiper(".mySwipersNearby", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".pagin-nearby",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
    // eslint-disable-next-line no-unused-vars
    const swiper11 = new Swiper(".mySwipersJourney", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".pagin-journey",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
}

export function initVenueSwiper() {
    // eslint-disable-next-line no-unused-vars
    var swiper6 = new Swiper(".mySwiperHero", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        effect: "fade",
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
    });

    // eslint-disable-next-line no-unused-vars
    var swiper7 = new Swiper(".mySwiperVenueImage", {
        pagination: {
          el: ".swiper-pagination-imgvenue",
          type: "fraction",
        },
        spaceBetween: 20,
        speed: 1000,
        navigation: {
          nextEl: ".swiper-button-next-imgvenue",
          prevEl: ".swiper-button-prev-imgvenue",
        },
    });
}

export function initOfferSwiper() {
  // eslint-disable-next-line no-unused-vars
  var swiper8 = new Swiper(".mySwiperOffers", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

export function initAwardSwiper(){
  // eslint-disable-next-line no-unused-vars
  const swiper9 = new Swiper(".mySwiperAwards", {
      slidesPerView: 1,
      spaceBetween: 0,
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      navigation: {
          nextEl: ".next-awards",
          prevEl: ".prev-awards",
        },
      breakpoints: {
        430: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
  });
}
